import { ApolloClientOptions } from 'lib/apollo-client';
import { createContext, Dispatch, SetStateAction } from 'react';

interface ApolloClientOptionsContextType {
  setClientOptions: Dispatch<SetStateAction<ApolloClientOptions>>;
}

const ApolloClientOptionsContext = createContext<ApolloClientOptionsContextType>(
  { setClientOptions: () => null }
);

export default ApolloClientOptionsContext;
